import styled from 'styled-components';
import { motion } from 'framer-motion';
import { th } from 'style/theme';

export const Container = styled.span`
  position: relative;
`;

export const StyledTerm = styled.span`
  border-bottom: 1px solid ${th('colors.turquoise')};
  white-space: nowrap;
  background-color: ${th('colors.turquoise')}1A;
  transition: 200ms;
  z-index: 0;

  :hover {
    background-color: ${th('colors.yellow')}66;
  }
`;

export const HoverWrapper = styled(motion.div)`
  position: absolute;
  top: 34px;
  left: 50%;
  transform: translate(-50%);
  width: 300px;
  max-width: calc(100vw - 40px);
  opacity: 0;
  z-index: ${th('zIndexes.dropdown')};
`;

export const Definition = styled(motion.div)`
  position: absolute;
  top: 4px;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: initial;
  background-color: ${th('colors.black')};
  color: ${th('colors.white')};
  white-space: pre;
`;

export const Arrow = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 50%;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  transform: translateX(-50%) rotate(51deg) skew(15deg);
  background-color: ${th('colors.black')};
`;
